const BASE64_KEYS = new Set([
    'fileBase64',
    'base64',
    'content',
    'fileContent',
    'attachment',
    'file',
    'data'
]);

const isBase64String = (value: string): boolean => {
    if (!value) return false;

    // data:image/png;base64,...
    if (/^data:.*;base64,/i.test(value)) {
        return true;
    }

    // Long Base64 string
    return (
        value.length > 100 &&
        /^[A-Za-z0-9+/=\r\n]+$/.test(value)
    );
};

const sanitizeText = (text: string): string => {
    return text
        .normalize('NFKD')
        // Remove emoji
        .replace(
            /[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}]/gu,
            ''
        )
        // Remove mathematical bold/italic Unicode
        .replace(/[\u{1D400}-\u{1D7FF}]/gu, '')
        .trim();
};

export const serializePayload = <T>(payload: T): T => {
    const serialize = (value: any, key?: string): any => {
        if (value === null || value === undefined) {
            return value;
        }

        if (value instanceof Date) {
            return value;
        }

        if (typeof value === 'string') {
            if (
                (key && BASE64_KEYS.has(key)) ||
                isBase64String(value)
            ) {
                return value;
            }

            return sanitizeText(value);
        }

        if (Array.isArray(value)) {
            return value.map((item) => serialize(item));
        }

        if (typeof value === 'object') {
            const result: Record<string, any> = {};

            Object.entries(value).forEach(([k, v]) => {
                result[k] = serialize(v, k);
            });

            return result;
        }

        return value;
    };

    return serialize(payload);
};